import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import functions from "../../../../utils/functionsFirebase";
import {toast} from "react-toastify";
import avatarDefault from "../../../../images/avatardefault.png";
import {getCachedImageUrl} from "../../../../utils/utils";

function InviteMenu({group}) {

    const intl = useIntl();
    const [username, setUsername] = useState("");
    const [code, setCode] = useState("");

    const [loading, setLoading] = useState(false);

    function validUsername() {
        return username?.length > 0;
    }

    function validCode() {
        return code?.length === 4 || (!code?.length && !username?.length);
    }

    async function sendInvitation() {
        if (!validUsername() || !validCode()) {
            return;
        }

        setLoading(true);
        const sendGroupInvitation = functions.httpsCallable('sendGroupInvitation');
        try {
            const res = await sendGroupInvitation({groupId: group.id, username, code});
            if (res.data.error) {
                switch (res.data.error) {
                    case 'ALREADY_JOINED':
                        toast.error(<div>
                            <FormattedMessage id="group-details.group-menu.invited-info.already-joined"/>
                        </div>)
                        break;
                    case 'ALREADY_INVITED':
                        toast.error(<div>
                            <FormattedMessage id="group-details.group-menu.invited-info.already-invited"/>
                        </div>)
                        break;
                }

            } else {
                const user = res.data.targetUser;
                toast.success(
                    <div>
                        <FormattedMessage id="group-details.group-menu.invited-info"/>
                        <li className="list-group-item" key={user.uid ?? user}>
                            <div
                                className="d-flex flex-row justify-content-between align-items-center">
                                <div className="d-flex flex-row align-items-center">
                                    <img style={{height: '3rem'}} className="image-border"
                                         src={user.photoURL ? getCachedImageUrl(user.photoURL) : avatarDefault}/>
                                    <div className="d-flex flex-column">
                                        <span className="ms-2">{user.displayName}</span>
                                        <span className="ms-2" style={{
                                            fontSize: "small",
                                            fontWeight: "lighter"
                                        }}>#{user.userCode}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>)
                setUsername("");
                setCode("");
            }
        } catch (e) {
            toast.error(<div>
                <FormattedMessage id="group-details.group-menu.invited-info.not-found"/>
            </div>)
        }
        setLoading(false);
    }

    return (<div>
        <div className="input-group">
            <input type="text" className="form-control" style={{width: "30%"}}
                   placeholder={intl.formatMessage({id: "users.input.user"})}
                   aria-label={intl.formatMessage({id: "users.input.user"})} value={username}
                   onChange={e => setUsername(e.target.value)}/>
            <span className="input-group-text">#</span>
            <input type="text" className={"form-control " + (!validCode() && " is-invalid")}
                   placeholder={intl.formatMessage({id: "profile.user-code"})}
                   aria-label={intl.formatMessage({id: "profile.user-code"})} value={code}
                   onChange={e => setCode(e.target.value)}/>
        </div>
        <div className="col-auto mt-3">
            <button disabled={!validUsername() || !validCode() || loading} onClick={sendInvitation} type="submit"
                    className="btn btn-secondary">Send
                {loading && <i className="fa-solid fa-spinner fa-spin ms-1"></i>}</button>
        </div>
    </div>)
}


export default InviteMenu;
